export default "__VITE_ASSET__DEf91NRz__"